// eslint-disable-next-line import/prefer-default-export
export const getProgressPercentage = (currentTime, currentChapterDuration) => {
  if (currentChapterDuration > 0)
    return Math.floor((currentTime / currentChapterDuration) * 100)
  return 0
}
